import { ApolloQueryResult, gql } from '@apollo/client';
import { Button } from 'components/buttons/button';
import { useGetShippingBlockDataQuery } from 'lib/graphql-generated';
import { useState } from 'react';
import { NewShippingOption } from './shipping-new-option';
import { ShippingSegment } from './shipping-segment';

const GET_SHIPPING_BLOCK_DATA = gql`
  query GetShippingBlockData {
    ## Shipping Options by Country
    countries(
      where: {
        shipping_options: {
          id: { _is_null: false }
          deleted_at: { _is_null: true }
        }
      }
      order_by: { code: asc }
    ) {
      name
      code
      shipping_options(
        where: { deleted_at: { _is_null: true } }
        order_by: { from: asc }
      ) {
        __typename
        id
        name
        price
        from
        to
        description
      }
    }

    ## Shipping Options by Region
    regions(
      where: {
        shipping_options: {
          id: { _is_null: false }
          deleted_at: { _is_null: true }
        }
      }
      order_by: { code: asc }
    ) {
      name
      code
      shipping_options(
        where: { deleted_at: { _is_null: true } }
        order_by: { from: asc }
      ) {
        id
        name
        price
        from
        to
        description
      }
    }
  }
`;

export const ShippingBlock = () => {
  const [isAddingOption, setIsAddingOption] = useState<boolean>(false);
  const { data, loading, error } = useGetShippingBlockDataQuery();

  return (
    <>
      <article className='flex flex-col space-y-8 pt-8'>
        <Button
          buttonSize='lg'
          buttonType='secondary'
          className='mr-auto ml-auto xl:ml-auto xl:mr-0'
          onClick={() => setIsAddingOption(!isAddingOption)}>
          {isAddingOption ? 'Cancel' : 'Add New'}
        </Button>
        {isAddingOption && (
          <NewShippingOption handleSuccess={() => setIsAddingOption(false)} />
        )}
        <section className=''>
          <dl className='space-y-8'>
            {data?.countries.length === 0 &&
            data?.regions.length === 0 &&
            !isAddingOption ? (
              <p className='text-center pb-6 text-gray-700'>
                Add your first shipping option!
              </p>
            ) : (
              <>
                {data?.countries.map((c) => (
                  <ShippingSegment
                    key={c.code}
                    name={c.name}
                    options={c.shipping_options.map((o) => ({
                      id: o.id,
                      name: o.name,
                      description: o.description,
                      from: o.from,
                      to: o.to,
                      price: o.price,
                    }))}
                  />
                ))}
                {data?.regions.map((r) => (
                  <ShippingSegment
                    key={r.code}
                    name={r.name}
                    options={r.shipping_options.map((o) => ({
                      id: o.id,
                      name: o.name,
                      description: o.description,
                      from: o.from,
                      to: o.to,
                      price: o.price,
                    }))}
                  />
                ))}
              </>
            )}
          </dl>
        </section>
      </article>
    </>
  );
};
